import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { ICustomCta, ICustomCtaForm } from '@campaign-form/campaign-form.interface';
import {
  IExpectedKpi,
  IExpectedKpiForm,
} from '../../../expected-kpi-step/execution-expected-kpi-list/execution-expected-kpis/expected-kpi-list/expected-kpi/expected-kpi.interface';

export interface IExecution extends ICustomCta {
  name: string | null;
  duration: number | null;
  expectedKpis?: IExpectedKpi[];
  id: string;
  executionDate: Date | null;
  executionTime: Date | null;
  executionType: EExecutionType | null;
  executionCountTarget: number | null;
}

export interface IExecutionForm extends ICustomCtaForm {
  duration: FormControl<number | null>;
  expectedKpis: FormArray<FormGroup<IExpectedKpiForm>>;
  id: FormControl<string | null>;
  isNew: FormControl<boolean | null>;
  executionDate: FormControl<Date | null>;
  executionTime: FormControl<Date | null>;
  executionType: FormControl<EExecutionType | null>;
  name: FormControl<string | null>;
  executionCountTarget: FormControl<number | null>;
}

export type TExecutionApi = Omit<IExecution, 'executionDate' | 'executionTime'> & {
  executionDate: string | null;
  executionTime: string | null;
};

export interface IModeChangeEvent {
  event: MatSlideToggleChange;
  modeSwitchTooltip?: MatTooltip;
}

export enum EExecutionType {
  unique = 'unique',
  undesignated = 'undesignated',
  always = 'always',
}
